const PROMOTION_ROUTE_NAMES = ['SmsPayment', 'Nudg '];
const PAYMENT_EXIT_FLAG = 'nudgPromotionPaymentExit';

let isPopStateNavigation = false;

export function isPromotionRoute(route) {
  return Boolean(route && PROMOTION_ROUTE_NAMES.includes(route.name));
}

export function isPromotionPath(pathname) {
  const path = pathname || window.location.pathname;
  return /^\/p\/[^/]+\/[^/]+\/?$/.test(path) || /^\/nudg\/[^/]+\/?$/.test(path);
}

export function markPromotionPaymentExit() {
  sessionStorage.setItem(PAYMENT_EXIT_FLAG, '1');
}

function consumePromotionPaymentExit() {
  if (sessionStorage.getItem(PAYMENT_EXIT_FLAG)) {
    sessionStorage.removeItem(PAYMENT_EXIT_FLAG);
    return true;
  }
  return false;
}

export function hardReloadPromotionPage() {
  window.location.reload();
}

export function setupPromotionReloadHandlers() {
  window.addEventListener('popstate', () => {
    isPopStateNavigation = true;
  });

  window.addEventListener('pageshow', (event) => {
    if (!isPromotionPath()) {
      return;
    }

    const returningFromPayment = consumePromotionPaymentExit();
    if (event.persisted || returningFromPayment) {
      hardReloadPromotionPage();
    }
  });
}

export function shouldHardReloadPromotionOnBack(to, from) {
  return isPopStateNavigation && isPromotionRoute(to) && from && from.name;
}

export function clearPopStateNavigationFlag() {
  isPopStateNavigation = false;
}
